import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — 336×280 large rectangle (rendered @2× = 672×560).
 * Horizontal logo lockup; shared body in ../GdnAdTemplate.
 */
const LargeRectangleAds = ({id, zoom}) => (
  <GdnAdTemplate id={id} zoom={zoom} variant="horizontal" />
);

export default LargeRectangleAds;
